module.exports = __webpack_public_path__ + "img/navigator_bar_add.737e03bd.svg";